module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "box box-solid box-clear"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row content-centered profile"
  }, [_c('croppa', {
    attrs: {
      "width": 350,
      "height": 350,
      "placeholder": "Click here to choose an image.",
      "placeholder-font-size": 14,
      "accept": ".png,.jpg,.jpeg,.gif",
      "prevent-white-space": true,
      "zoom-speed": 5
    },
    on: {
      "init": _vm.onReady,
      "image-remove": _vm.onImageRemove,
      "file-type-mismatch": _vm.onFileTypeMismatch,
      "file-size-exceed": _vm.onFileSizeExceed,
      "file-choose": _vm.onFileChoose
    },
    model: {
      value: (_vm.profileImage),
      callback: function($$v) {
        _vm.profileImage = $$v
      },
      expression: "profileImage"
    }
  }, [_c('img', {
    attrs: {
      "slot": "initial",
      "crossorigin": "anonymous",
      "src": _vm.displayUrl
    },
    slot: "initial"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "slot": "placeholder",
      "src": "/static/img/fa-expand.png"
    },
    slot: "placeholder"
  })])], 1), _vm._v(" "), (_vm.fileUploading) ? _c('div', {
    staticClass: "box box-solid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "progress active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success progress-bar-striped",
    style: ('width: ' + _vm.percentCompleted + '%'),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.percentCompleted,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.percentCompleted) + "% Complete")])])])])]) : _vm._e(), _vm._v(" "), (_vm.profileloading && _vm.percentCompleted >= 100) ? _c('div', {
    staticClass: "box box-solid"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body content-centered"
  }, [_c('pulse-loader')], 1)]) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "content-centered"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "disabled": (!_vm.profileImage.hasImage() || _vm.profileImageUrl.includes('gravatar') || !this.dirty) && !_vm.fileChosen
    },
    on: {
      "click": _vm.setProfileImage
    }
  }, [_vm._v("Set Profile Image")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "15px"
    },
    attrs: {
      "disabled": _vm.profileImageUrl.includes('gravatar') || _vm.profileloading
    },
    on: {
      "click": _vm.removeProfileImage
    }
  }, [_vm._v("Remove Profile Image")])])]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "overlay"
  }, [_c('i', {
    staticClass: "fa"
  }, [_c('pulse-loader')], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header content-centered"
  }, [_c('h3', [_vm._v("Uploading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header content-centered"
  }, [_c('h3', [_vm._v("Finalizing...")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ad8d0252", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad8d0252"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/profile/ProfileImage.vue
// module id = 2373
// module chunks = 0